<template>
  <div>
    <div class="page-header clear-filter" filter-color="black3">
      <parallax
        v-bind:useScroll="false"
        class="page-header-image"
        style="background-image:url('/img/img_map.png')"
      ></parallax>
      <div style="position:absolute;top:400px;">
          <a href='https://widget.kyber.network/v0.6.2/?type=swap&mode=popup&callback=https%3A%2F%2Fkyberpay-sample.knstats.com%2Fcallback&paramForwarding=true&network=ropsten&defaultPair=ETH_DAI&commissionId=0x0000111122223333444455556666777788889999&productImage=https://images.unsplash.com/photo-1518791841217-8f162f1e1131&theme=theme-emerald'
  class='kyber-widget-button theme-emerald theme-supported' name='KyberWidget - Powered by KyberNetwork' title='Pay with tokens'
  target='_blank'>Swap tokens</a>
      </div>
      <div class="package-area">
        <div class="package-item">1차 프리세일 기간 ~5/30</div>
        <div class="package-item" v-for="item in packages" v-bind:key="item.rank">
          <span class="column">Rank {{item.rank}}</span>
          <span class="column">{{PRICES[item.rank]}} ETH</span>
          <span @click="decreaseAmount(item)">-</span>
          <span>{{item.amount}}</span>
          <span class="column" @click="increaseAmount(item)">+</span>
          <span>남은 Land : {{REMAINS[item.rank]}} </span>
        </div>
        <div class="package-item">총 {{amount.total}}개</div>
        <div>
        <select v-model="token" @change="onTokenChange($event)">
          <option v-for="item in tokens" v-bind:key="item.token_symbol" v-bind:value="item.token_symbol">
            {{ item.token_symbol }}
          </option>
        </select>
        </div>
        <div class="package-item">1 {{selectedToken.token_symbol}} = {{selectedToken.rate_eth_now}} ETH = {{selectedToken.rate_usd_now}} USD </div>
        <div
          @click="buy()"
          style="width: 144px; height: 68px; background-image: url('/img/btn_144.png'); font-size: 1.2em;
                  font-weight: 400;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  text-align: center;
                  color: #fff568; padding-top: 20px;margin:auto;left:0;right:0;"
          class="btn"
        >
          {{$t('Buy')}}
          <br />
          {{amount.price/selectedToken.rate_eth_now}} {{selectedToken.token_symbol}}
        </div>
        <!-- <div
          @click="swap()"
          style="width: 144px; height: 68px; background-image: url('/img/btn_144.png'); font-size: 1.2em;
                  font-weight: 400;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  text-align: center;
                  color: #fff568; padding-top: 20px;margin:auto;left:0;right:0;"
          class="btn"
        >
          {{$t('Swap')}}
          <br />
          {{amount.price}} ZIL
        </div> -->
        <div
          @click="clearAmount()"
          style="width: 144px; height: 68px; background-image: url('/img/btn_144.png'); font-size: 1.2em;
                  font-weight: 400;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  text-align: center;
                  color: #fff568; padding-top: 20px;margin:auto;left:0;right:0;"
          class="btn"
        >{{$t('Clear')}}</div>
      </div>
      <div class="wallet-area">
        <div class="connect" v-if="account==null">
          <div>지갑연결</div>
          <div @click="connect('metamask')">metamask</div>
          <div @click="connect('dappcom')">dapp.com</div>
          <div @click="connect('torus')">torus</div>
          <div @click="connect('trust')">trustwallet</div>
        </div>
        <div class="account" v-if="account!=null">
          <div>연결된 지갑: {{account.address}}</div>
          <div>잔액: {{Number(account.balance).toFixed(4)}} ETH</div>
          <div @click="disconnect()">연결끊기</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { Parallax, Button } from "@/components";
import axios from 'axios'
import config from '../config.js';
import MapLayer from '../components/partials/MapLayer.vue';
import GridLayer from '../components/partials/GridLayer.vue';
// import { OrderSide } from 'opensea-js/lib/types';
// import { OpenSeaPort, Network } from 'opensea-js';
import KingdomLandSale from './KingdomLandSale.json';
import Web3 from 'web3';
import Torus from "@toruslabs/torus-embed";
const NETWORK = "rinkeby";//4;//process.env.NETWORK
const API_KEY = "714121e92d814fed8234b8168ffa8f9c";
const web3Provider = window.ethereum;
var web3;//= new Web3('ws://localhost:8546');
var contract;
let seaport;
// if (web3Provider) {
//   // seaport = new OpenSeaPort(web3Provider,  {
//   //   networkName: NETWORK === 'mainnet' ? Network.Main : Network.Rinkeby,
//   //   apiKey: API_KEY
//   // });
//   web3 = new Web3(web3Provider);
//   contract = new web3.eth.Contract(KingdomLandSale.abi, KingdomLandSale.networks[4].address);

// }
const HIDE_GRID_WHEN_SCROLLING = true;
function ETH(value) {
  return web3.utils.fromWei(value, 'ether');
}
function WEI(value) {
  return web3.utils.toWei(value, 'ether');
}
export default {
  name: 'Map',
  components: { Parallax, [Button.name]: Button },
  data: () => ({
    viewport: {
      left: 0,
      top: 0,
      width: 0,
      height: 0,
    },
    isScrolling: false,
    scrollingTimer: null,
    mousedownFlag: false,
    mousedownOffset: null,
    showGridChecked: true,
    visibleDevRank: 'off',
    selectedLandId: 0,
    landInfo: {
    },
    account:null,
    carts: [],
    total: 0,
    objects: [],
    trees: [],
    PRICES: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    REMAINS: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    amount:{total:0,price:0},
    selectedToken:{symbol:"ETH",rate:1},
    exchangeRate:1,
    token:"ETH",
    tokens:[{name:"ETH", value:"eth"},{name:"KNC", value:"knc"}],
    tokenMap:{},
    packages: [{"rank":2,"amount":0},{"rank":3,"amount":0},{"rank":4,"amount":0},{"rank":5,"amount":0},{"rank":6,"amount":0}],
  }),
  computed: {
    currentLandId() {
      return this.$store.state.area.selectedLand;
    },
    currentZone() {
      return this.$store.state.map.currentZone;
    },
    renderGrid() {
      return !HIDE_GRID_WHEN_SCROLLING || !this.isScrolling;
    }
  },
  mounted() {
    // this.$nextTick(() => {      
    // })
  },
  watch: {
    async currentLandId(val) {
      const treeCodes = [501, 502, 503, 504, 505, 601, 602, 603];
      this.trees = [];
      for (let i = 0; i < 10; ++i) {
        this.trees.push({
          _id: i,
          code: treeCodes[Math.floor(Math.random() * treeCodes.length)],
          x: Math.floor(Math.random() * 8) * 40,
          y: Math.floor(Math.random() * 8) * 40
        })
      }
      this.landInfo = await this.getLandInfo(val[0]);
      this.objects = await this.getFieldObjects(val[0]);
      this.selectedLandId = this.landInfo.landId;
    }
  },
  created: async function () {

    // var result = await contract.methods.getPrices(10).call();
    // this.PRICES = result.map(x => Number(ETH(x)).toFixed(4));
    // var usds = await fetch("https://api.kyber.network/currencies");

    var curs = await fetch("https://api.kyber.network/change24h");
    var data = await curs.json();
    var list = [];
    var map = {};
  for(var name in data)
  {
    var item = data[name];
    map[item.token_symbol] = item;
    list.push(item);
  }
  this.tokenMap = map;
  this.tokens = list;

      var rr = await fetch("http://192.168.12.228:8888/api/presale/info");
      var json = await rr.json();
      this.PRICES = json.prices;
      this.REMAINS = json.remains;
    // var saved = localStorage.getItem("amount");
    // if (saved != null) {
    //   this.carts = JSON.parse(saved);
    //   this.computeCart();
    // }
    this.computeAmount();

  },
  methods: {
    onTokenChange: async function (){
      console.log(this.token);
      if(this.tokenMap[this.token]==null)
        return;
      this.selectedToken = this.tokenMap[this.token];
      // this.exchangeRate = this.selectedToken.rate;
    },
    goToLandPage: function () {
      //this.$router.push(`/land/${this.selectedLandId}`)
      window.open(`${config.web.url}/land/${this.selectedLandId}`, '_blank');
    },
    increaseAmount: function (item){
      item.amount = Math.min(this.REMAINS[item.rank], item.amount+1);
      this.computeAmount();
    },
    clearAmount: function (){
      for(var item of this.packages)
        item.amount = 0;
      this.computeAmount();
    },
    decreaseAmount: function (item){
      item.amount = Math.max(0, item.amount-1);
      this.computeAmount();
    },
    computeAmount: function (){
      this.amount.total = 0;
      this.amount.price = 0;
      for(var item of this.packages)
      {
        this.amount.total += item.amount;
        this.amount.price += item.amount*Number(this.PRICES[item.rank]);
      }
      this.amount.price = this.amount.price.toFixed(4);
    },
    saveCart: function () {
      localStorage.setItem("cart", JSON.stringify(this.carts));
      console.log("SAVE CART");
    },
    connect:async function(type){
      console.log(type);
      console.log(window.ethereum)
      console.log(window.ethereum.isMetaMask)
      var balance = 0;
      if(type=="metamask")
      {
        web3 = new Web3(web3Provider);
  
        const accounts = await window.ethereum.enable();
        web3 = new Web3(window.ethereum);
        console.log(accounts);
        this.account = {address:accounts[0],balance:0}
        balance = await web3.eth.getBalance(this.account.address);
        this.account.balance = ETH(balance);
      }else if(type=="dappcom"){
        console.log("DAPPCONNECTED")
        await window.loadScript("lib/DappStoreWallet-Ethereum");
        await window.loadScript("lib/web3.min");
        window.dappstore = new window.DappStoreWallet("d03db299-0231-49bf-95d6-5b4c6f898167");
        web3 = new Web3(window.dappstore.provider);
        console.log("DAPPCONNECTED")
        this.account = {address:web3.eth.accounts.currentProvider.selectedAddress,balance:0}
        balance = await web3.eth.getBalance(this.account.address);
        this.account.balance = ETH(balance);
      }else if(type=="torus"){
        const torus = new Torus();
        await torus.init({
        network: {
          host: "rinkeby" // default : 'mainnet'
        }});
        await torus.ethereum.enable();
        web3 = new Web3(torus.provider);
        console.log(web3.eth.accounts.currentProvider.selectedAddress);
        this.account = {address:web3.eth.accounts.currentProvider.selectedAddress,balance:0}
         balance = await web3.eth.getBalance(this.account.address);
        this.account.balance = ETH(balance);
      }
      contract = new web3.eth.Contract(KingdomLandSale.abi, KingdomLandSale.networks[4].address);
      console.log("LOADED")
    },disconnect:async function(){
      this.account = null;
    },
    buy:async function(){
      if(this.account==null)
        return alert("지갑을 연결해주세요")
      // const accounts = await window.ethereum.enable();
      var amounts = [0,0];
      var price = 0;
      for(var item of this.packages)
      {
        console.log(item);
        amounts.push(item.amount);
        if(item.amount==0)
          continue;
        price += Number(this.PRICES[item.rank])*item.amount;
      }
      if(item.amount==null)
        return alert("구매할 상품을 선택해주세요")
      try{

      var rr = await fetch("http://192.168.12.228:8888/api/presale/buy?amounts=" + amounts.join(","));
      var data = await rr.json();
      var ids = data.ids;
      console.log(ids);
      var result = await this.send(contract.methods.buys(ids).encodeABI(), price);
      console.log(result);
      }catch(e){
        console.log("JSJ ERROR:", e)
      }
    },
    swap:async function(){
      if(this.account==null)
        return alert("지갑을 연결해주세요")
      // const accounts = await window.ethereum.enable();
      var amounts = [];
      var price = 0;
      for(var item of this.packages)
      {
        console.log(item);
        amounts.push(item.amount);
        if(item.amount==0)
          continue;
        price += Number(this.PRICES[item.rank])*item.amount;
      }
      if(item.amount==null)
        return alert("구매할 상품을 선택해주세요")
      try{

        const SRC_TOKEN_ADDRESS = "0x405A656Dc1b672800D21a15eF5539D4776F6654c";
        const DST_TOKEN_ADDRESS = "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee";
        const SRC_DECIMALS = 12;
        const DST_DECIMALS = 18;
        const MAX_ALLOWANCE = "115792089237316195423570985008687907853269984665640564039457584007913129639935";

        // Trade Details
        const SRC_QTY = "100";
        const SRC_QTY_WEI = (SRC_QTY * 10 ** SRC_DECIMALS).toString();
// var rr = await fetch("http://192.168.12.228:8888/api/presale/buy?amounts=" + amounts.join(","));
//       var data = await rr.json();
//       var ids = data.ids;
      // var result = await this.send(contract.methods.buys(ids).encodeABI(), price);
  // var result = await this.send(contract.methods.tokenBuy(ids, SRC_TOKEN_ADDRESS, SRC_QTY_WEI).encodeABI(), 0);
  var result = await this.send(contract.methods.swap(SRC_TOKEN_ADDRESS, SRC_QTY_WEI, DST_TOKEN_ADDRESS, "0xDb19E3C05D998D1a75B194ed34Ebc0FdE4e1Bb99", MAX_ALLOWANCE).encodeABI(), 0);
      console.log(result);
      }catch(e){
        console.log("JSJ ERROR:", e)
      }
    },
    send: async function (data, value, callback) {
      const param = {
        to: contract.options.address,
        from: web3.eth.currentProvider.selectedAddress,
        value: WEI(value.toString()), // Only required to send ether to the recipient from the initiating external account.
        data: data,
        // nonce: '0x00', // ignored by MetaMask
        // gasPrice: ETH(0.000001), // customizable by user during MetaMask confirmation.
        // gas: web3.toHex(21000),  // customizable by user during MetaMask confirmation.
        // chainId: 3
      }
      console.log(param);
      try {
        var result = await web3.eth.sendTransaction(param);
        return result;
      }
      catch (e) {
        console.log(e);
        return {};

      }
    },
    onMousedown(e) {
      this.mousedownFlag = true;
      this.mousedownOffset = {
        x: e.offsetX,
        y: e.offsetY,
      };
      this.isDragging = false;
    },
    onMousemove(e) {
      if (!this.mousedownFlag) {
        return;
      }
      if (this.isDragging) {
        this.adjustViewportPosition(-e.originalEvent.movementX, -e.originalEvent.movementY, 1);
      } else if (Math.abs(this.mousedownOffset.x - e.offsetX) + Math.abs(this.mousedownOffset.y - e.offsetY) > 2) {
        this.isDragging = true;
      }
    },
    onMouseup() {
      this.mousedownFlag = false;
      this.isDragging = false;
    },
    onClickMap() {
    },
  }
}
</script>

<style scoped>
.map-pos {
  position: absolute;
  right: 255px;
  top: 10px;
  font-size: 14px;
  color: #fff;
  user-select: none;
  text-align: right;
}
.map-title {
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  color: #00ff00;
  width: 600px;
  height: 50px;
  text-align: left;
}
.map-title-devrank {
  position: absolute;
  top: 80px;
  left: 255px;
  width: 800px;
  height: 50px;
  text-align: right;
}
.map-area {
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  width: 822px;
  height: 843px;
  background-image: url("/img/frame_zone.png");
  overflow: none;
}
.map-scroll-stage {
  position: absolute;
  top: 32px;
  left: 50%;
  transform: translateX(-50%);
  width: 800px;
  height: 800px;
  overflow: none;
}
.wallet-area {
  position: absolute;
  color:#fff;
  top: 580px;
  margin:auto;
  left:0;right:0;
  width: 328px;
  height: 328px;
  background-image: url("/img/frame_world.png");
  overflow: none;
}
.package-area {
  position: absolute;
  top: 180px;
  margin:auto;
  left:0;right:0;
  width: 328px;
  height: 328px;
  background-image: url("/img/frame_world.png");
  overflow: none;
}
.package-title {
  position: absolute;
  top: 120px;
  width: 328px;
  height: 50px;
  text-align: center;
}
.package-item {
  color: white;
}
.package-item .column{
  margin-right:20px;
}
.cart-area {
  position: absolute;
  top: 480px;
  right: calc(50% + 436px);
  width: 328px;
  height: 328px;
  background-image: url("/img/frame_world.png");
  overflow: none;
}
.cart-title {
  position: absolute;
  top: 120px;
  width: 328px;
  height: 50px;
  text-align: center;
}
.cart-item {
  color: white;
}
.minimap-area {
  position: absolute;
  top: 120px;
  right: calc(50% + 436px);
  width: 328px;
  height: 328px;
  background-image: url("/img/frame_world.png");
  overflow: none;
}
.minimap-title {
  position: absolute;
  top: 120px;
  width: 328px;
  height: 50px;
  text-align: center;
}
.minimap-scroll-stage {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 320px;
  height: 320px;
  overflow: none;
}
.land-info-title {
  position: absolute;
  top: 3px;
  width: 320px;
  height: 50px;
  text-align: center;
  color: white;
}
.land-info-area {
  position: absolute;
  top: 473px;
  left: calc(50% + 436px);
  width: 328px;
  height: 471px;
  overflow: none;
  background-image: url("/img/frame_field_info.png");
  padding: 10px;
}
.gamemap-area {
  position: absolute;
  top: 100px;
  left: calc(50% + 436px);
  width: 328px;
  height: 349px;
  background-image: url("/img/frame_field.png");
  overflow: none;
}
.gamemap-title {
  position: absolute;
  top: 3px;
  width: 320px;
  height: 50px;
  text-align: center;
  color: white;
}
.gamemap-scroll-area {
  position: absolute;
  top: 25px;
  left: 4px;
  width: 320px;
  height: 320px;
  background-image: url("/img/map/map_01.png");
  overflow: none;
}
.map-area.dragging {
  cursor: move;
}
.map-selector {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 150px;
  font-size: 12px;
  user-select: none;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 3px;
  color: #000;
  border: 1px solid #000;
}
.map-selector ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.urban-list {
}
.urban-list .urban-item {
  position: relative;
}
.urban-list .urban-item > span {
  display: block;
  padding: 10px;
  border-top: 1px solid #ccc;
  cursor: pointer;
}
.urban-list .urban-item:first-child > span {
  border-top: none;
}
.urban-list .urban-item::after {
  content: "+";
  position: absolute;
  right: 10px;
  top: 5px;
  font-size: 25px;
  color: #666;
}
.urban-list .urban-item.active::after {
  content: "-";
}
.map-list {
  max-height: 400px;
  overflow-y: auto;
  background-color: #f0f0f0;
}
.map-list .map-item {
  display: none;
}
.map-list .map-item a {
  display: block;
  padding: 5px;
  border-top: 1px solid #ccc;
  font-size: 11px;
  color: #333;
  text-decoration: none;
  outline: none;
}
.map-list .map-item a:hover {
  background-color: #e5e5e5;
}
.map-list .map-item a::before {
  content: "-";
  display: inline-block;
  padding: 0 5px;
}
.map-list .map-item.active a {
  background-color: #e5e5e5;
}
.map-list .map-item.active a::before {
  content: ">>";
}
.urban-list .urban-item.active .map-item {
  display: block;
}
.map-list .map-item.active {
  display: block;
}
table,
th,
td {
  border: 0px solid white !important;
  min-width: 0px !important;
  min-height: 0px !important;
}
</style>